export default __webpack_public_path__ + "static/media/banner.d0eb05ab.png";